import React from 'react';

import {
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
} from "@chakra-ui/react"
import { useToggle } from 'react-use';
import AnalyticsQuestionUserModal from './AnalyticsQuestionUserModal';

import { AnswerForMappingFragment } from "../../graphql/generated/definitions";

export type AnalyticsQuestionStatProps = {
  answers: AnswerForMappingFragment[],
  label: string,
  value: string,
  populationCount: number
};


const AnalyticsQuestionStat: React.FC<AnalyticsQuestionStatProps> = ({
  answers,
  label,
  value,
  populationCount
}) => {
  const answersForOption = answers.filter((answer) => (
    answer.selector === value
  ));

  const part = Math.round((answersForOption.length / populationCount) * 100);

  const [ modalOpen, toggleModalOpen ] = useToggle(false);

  return (
    <>
      <Stat
        role="button"
        onClick={toggleModalOpen}
      >
        <StatLabel>{label}</StatLabel>
        <StatNumber>
          {answersForOption.length}
        </StatNumber>
        <StatHelpText>
          {`${part}%`}
        </StatHelpText>
      </Stat>
      <AnalyticsQuestionUserModal
        answers={answersForOption}
        isOpen={modalOpen}
        onClose={toggleModalOpen}
        label={label}
       />
    </>
  );
}

export default React.memo(AnalyticsQuestionStat);
